import {
  AfterViewInit,
  Component,
  Input,
  OnChanges,
  OnInit,
  QueryList,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import {
  AutoRoutingService
} from '../../services/auto-routing.service';
import { ActivatedRoute, Params } from '@angular/router';
import { AutoRoutingByDriverComponent } from './components/auto-routing-by-driver/auto-routing-by-driver.component';
import { AutoRoutingDriversComponent } from './components/auto-routing-drivers/auto-routing-drivers.component';
import { SweetAlertHelper } from 'app/core/helpers/sweet-alert-helper.service';

@Component({
  selector: 'app-auto-routing-results',
  templateUrl: './auto-routing-results.component.html',
  styleUrls: ['./auto-routing-results.component.scss']
})
export class AutoRoutingResultsComponent implements OnInit, OnChanges, AfterViewInit {
  @Input() jobId: any; // Para la gestion del parametro jobId en los componentes hijos.
  @Input() activeExport = false; // para activar el boton de Exportar en Excel.
  tab = 0; // Tab activo por defecto
  codesSelected:  Array<any> = []; // Array para gestionar los driver que se seleccionado en la grid de Driver- Izq
  onLoadSchedules: any[] = []; // Almacena los Schedule que se cargan por driver.
  driver: any[] = [];
  exportJob = false;
  tripsUnassigned: any[] = []; // Almacena todos los trip unasigned
  showUnassignedMap: boolean; // Tetermina si se muestra o no los unassigned en el mapa
  onPointsSelected: any[] = []; // Arraray para procesar los puntos seleccionados de la grid de unassigned
  @ViewChild(AutoRoutingByDriverComponent) tabElements: QueryList <AutoRoutingByDriverComponent>;
  @ViewChild(AutoRoutingByDriverComponent) protected tabDrive: AutoRoutingByDriverComponent;
  @ViewChild('driverSection') private driverSection: AutoRoutingDriversComponent;
  arrayActiveSI = [];
  constructor(
    private _autoRoutingService: AutoRoutingService,
    private rutaActiva: ActivatedRoute,
    private sweetAlertHelper: SweetAlertHelper,
    ) {
    this.rutaActiva.params.subscribe((params: Params) => {
      this.jobId = params['id'];
      window.document.title = 'Autorouting Job ID : ' + this.jobId;
    });
  }

  recalculate(id) {
    this.sweetAlertHelper.createCustomAlert({
      title: 'Recalculate',
      text: "Are you sure you want to recalculate?",
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, recalculate'
    }).then((result) => {
      if (result.value) {
        this.tabDrive.recalculateProcess(id);
        this.deleteActiveBtn(id);
      }
    });
  }

  ngOnInit() {
    this.loadDriver();
    this.loadTripsUnassigned();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['jobId']) {
      this.loadDriver();
    }
    /*if (changes['activeExport'].currentValue) {

    }*/
  }

  ngAfterViewInit(): void {
  }

  selectDriver(event) {
    this.driverSection.selectDriver(event);
  }


  loadDriver() {
    this._autoRoutingService.getDrivers(this.jobId).subscribe(
      data => {
       /* if (data) {
          this.exportJob = true;
        } */
        this.driver = data;
      }
    );
  }

  loadTripsUnassigned() {
    if (this.jobId !== undefined) {
      this._autoRoutingService.getUnassignedTrips(this.jobId).subscribe(
        data => {
          this.tripsUnassigned = data;
        }
      );
      // this.tabElements.forEach((item) => {
      //   item.getTripsForVehicle();
      // });
    }
  }

  private selectedBefore;
  onCodeSelected(event) {

    if (!this.selectedBefore) {
      this.selectedBefore = event;
    }

    this.codesSelected = event;
    event.length === 1 ? this.tab = 0 : this.tab = event.length;

    this.tab = this.arr_diff(this.selectedBefore, this.codesSelected);
    this.selectedBefore = event;
  }

  private arr_diff (a1, a2) {
    let found;
    a2.forEach((item, index) => {
      const i = a1.findIndex(itm => itm.scheduleid === item.scheduleid);
      if (i === -1) {
        found = index + 1;
      }
    })

    if (!found) {
      return a2.length;
    }

    return found;
}
  addLoadSchedule($event) {
    // this.onLoadSchedules = [];
    if ($event.length !== 0) {
      this.onLoadSchedules.push($event);
      this.onLoadSchedules = this.onLoadSchedules.slice();
    }
  }

  onDeleteElementsForSheduleid($event) {
    this.onLoadSchedules.filter((row, index) => {
      if (row.length > 0) {
        if (row[0].scheduleid == $event) {
          this.onLoadSchedules.splice(index, 1);
        }
      }
    });
    this.onLoadSchedules = this.onLoadSchedules.slice();
  }

  arrayActiveBtn(id) {
    let add = true;
    if (this.arrayActiveSI.length === 0) {
      this.arrayActiveSI.push({'scheduleid': id});
    } else {
      this.arrayActiveSI.map ( f => {
        if (f.scheduleid === id) {
          add = false;
        }
      });
      if (add) {
        this.arrayActiveSI.push({'scheduleid': id});
      }
    }
  }

  btnActive(id) {
    let query = false;
    this.arrayActiveSI.map( f => {
      if (f.scheduleid === id) {
        query = true;
      }
    });
    return query;
  }

  deleteActiveBtn(e) {
    this.arrayActiveSI.map( (f, i) => {
      if (f.scheduleid === e) {
        this.arrayActiveSI.splice(i, 1);
      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/auto-routing-results/auto-routing-results.component.ts